<template>
<div>
  <el-dialog title="创建新应用" :visible.sync="temp.dialogVisible" v-if="temp.dialogVisible" width="35%">
    <el-form :model="formData" label-position="right" label-width="100px" ref="form">
      <el-form-item v-for="(item, index) of formData" :key="index" :label="item.label" :rules="formData[index].rules" :prop="'[' + index + '].value'">
        <el-input v-model="formData[index].value" :type="formData[index].type"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" plain :disabled="isSave" @click="save">保存</el-button>
        <el-button @click="temp.dialogVisible = false">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</div>
</template>

<script>
import { saveProject } from '@/api/project-controller'

export default {
  name: 'projectDialog',
  inject: ['reload'],
  props: ['temp', 'projectData'],
  data () {
    // const validatePhone = (rule, value, callback) => {
    //   // const valid = /(13\d|14[579]|15[^4\D]|17[^49\D]|18\d)\d{8}/g
    //   const valid = /^1\d{10}$/
    //   if (value === '' || value === null) {
    //     callback()
    //   } else {
    //     if (valid.test(value)) {
    //       callback()
    //     } else {
    //       callback(new Error('请输入正确手机号'))
    //     }
    //   }
    // }
    // const postcode = (rule, value, callback) => {
    //   const valid = /^[1-9][0-9]{5}$/
    //   if (value === '' || value === null) {
    //     callback()
    //   } else {
    //     if (valid.test(value)) {
    //       callback()
    //     } else {
    //       callback(new Error('请输入正确邮政编码'))
    //     }
    //   }
    // }
    const checkName = (rules, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('名称不可为空，请输入'))
      } else {
        callback()
      }
    }
    return {
      isSave: false,
      formData: {
        title: {
          label: '应用名称',
          value: '',
          hasValue: false,
          rules: [
            { required: true, message: '请输入应用名称', trigger: 'blur' },
            { max: 12, message: '应用名称不超过12位', trigger: 'blur' },
            { validator: checkName, trigger: 'blur' }
          ],
          type: 'string'
        }
        // email: {
        //   label: '邮箱',
        //   value: '',
        //   hasValue: false,
        //   rules: [
        //     // { required: true, message: '请输入用户邮箱', trigger: 'blur' },
        //     { type: 'email', message: '请输入正确邮箱地址', trigger: 'blur' }
        //   ],
        //   type: 'string'
        // },
        // phone: {
        //   label: '联系手机',
        //   value: '',
        //   hasValue: false,
        //   rules: [
        //     { validator: validatePhone, trigger: 'blur' }
        //   ],
        //   type: 'string'
        // },
        // country: {
        //   label: '国家',
        //   value: '',
        //   hasValue: false,
        //   type: 'string',
        //   rules: [
        //     { max: 20, message: '输入不可超过20位', trigger: 'blur' }
        //   ]
        // },
        // state: {
        //   label: '省',
        //   value: '',
        //   hasValue: false,
        //   rules: [
        //     { max: 20, message: '输入不可超过20位', trigger: 'blur' }
        //   ],
        //   type: 'string'
        // },
        // city: {
        //   label: '城市',
        //   value: '',
        //   hasValue: false,
        //   rules: [
        //     { max: 20, message: '输入不可超过20位', trigger: 'blur' }
        //   ],
        //   type: 'string'
        // },
        // address: {
        //   label: '地址',
        //   value: '',
        //   hasValue: false,
        //   rules: [
        //     { max: 40, message: '输入不可超过40位', trigger: 'blur' }
        //   ],
        //   type: 'string'
        // },
        // zip: {
        //   label: '邮编',
        //   value: '',
        //   hasValue: false,
        //   rules: [
        //     { validator: postcode, trigger: 'blur' },
        //     { max: 20, message: '名称不超过20位', trigger: 'blur' }
        //   ],
        //   type: 'string'
        // },
        // region: {
        //   label: '地区',
        //   value: '',
        //   hasValue: false,
        //   rules: [
        //     // { validator: textControl, trigger: 'blur' },
        //     { max: 40, message: '输入不可超过40位', trigger: 'blur' }
        //   ],
        //   type: 'string'
        // }
      }
    }
  },
  methods: {
    save () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.formData.title.value = this.formData.title.value.trim()
          console.log(this.formData, this.temp)
          for (const item of this.projectData) {
            if (item.title === this.formData.title.value) {
              this.$message.error('应用名称不可重复')
              return false
            }
          }
          this.temp.title = this.formData.title.value
          // for (const item in this.formData) {
          //   if (this.formData[item]) {
          //     this.temp[item] = this.formData[item].value
          //   }
          // }
          // if (this.temp.email) {
          //   this.temp.email = this.formData.email.value.toLowerCase()
          // }
          const params = Object.assign({}, this.temp)
          params.name = params.title
          delete params.dialogVisible
          console.log(params, this.temp)
          this.isSave = true
          saveProject(params).then(res => {
            this.$message({
              type: 'success',
              message: '创建成功'
            })
            this.temp.dialogVisible = false
            this.reload()
          })
          // this.$emit('Save')
          // this.temp.dialogVisible = false
        } else {
          this.$message.error('请按提示输入信息')
          return false
        }
      })
    }
  },
  created () {
    for (const item in this.temp) {
      if (this.formData[item]) {
        this.formData[item].value = this.temp[item]
        // this.formData[item].ja
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
/* reset element-ui css */
.el-dialog {
  width: 35%;
  margin-top: 5vh;
  margin-bottom: 5vh;
}
.el-dialog__wrapper {
  .el-dialog {
    .el-dialog__body {
      padding: 15px 30px 10px 20px;
    }
  }
}
</style>

<style lang="scss" scoped>
</style>
